
import { API_BASE_URL } from "~/utils/constants";

export default {
  name: 'layout',
  components: {
  },
  computed: {
  },
    data() {
        return {
            companyName: '',
        }
    },
    mounted() {
        var companyId = this.$auth.user.companyId
        var url = `${API_BASE_URL}/companies/read?companyId=${companyId}`;
        this.$api.get(url)
        .then(response => {
            this.companyName = response.data[0].name;
            // console.log(this.companyName)
        })
        .catch(error => {
            // console.log(error.response)
        });
    },
  methods: {
  }
}
